import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { withRouterProps } from '../../utils/with-router-props'

import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'
import { fetchApiDataIfNeeded } from '../../../actions/api'
import { Link } from 'react-router-dom'
import { PaginationWrapper } from 'shs-pagination'
import moment from 'moment'

const selectadminAccountPaginator = state => state.paginator.adminAccounts
const selectAccounts = state => state.adminAccounts
const makeAccounts = createSelector(
    [selectAccounts, selectadminAccountPaginator],
    (accounts, paginator) => {
        if (paginator) {
            return accounts
                .filter(field => paginator.itemIds.indexOf(field.id) !== -1)
                .sort((a, b) => {
                    if (paginator.itemIds.indexOf(a.id) > paginator.itemIds.indexOf(b.id)) {
                        return 1
                    }
                    return -1
                })
        }
        return []
    }
)

const mapStateToProps = (state, ownProps) => {
    const paginator = state.paginator.adminAccounts
    const accounts = makeAccounts(state)
    return { paginator, accounts }
}

const AdminAccountsList = ({ dispatch, paginator, accounts }) => {
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/accounts', 'LIST')))
    }, [dispatch])

    const renderAccountRow = (account, index) => {
        return (
            <tr key={account.id}>
                <td className="index mobile-hide">{index}.</td>
                <td className="main">
                    <Link to={buildRoutePath(routes.adminAccountDashboard.path, { accountId: account.id })}>
                        {account.name}
                    </Link>
                </td>
                <td className="main">{account._computed.accountTypeName}</td>
                <td className="main mobile-hide">{moment(account.createdAt).format('MMM Do \'YY h:mm a')}</td>
                <td className="main mobile-hide">
                    <Link className="btn outline small" to={buildRoutePath(routes.adminAccountView.path, { accountId: account.id })}>
                        Edit
                    </Link>
                </td>
            </tr>
        )
    }

    const handlePaginationUpdate = (paginationParams) => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint(`admin/accounts`, 'LIST'), paginationParams))
    }

    const renderAccounts = () => {
        if (!paginator) {
            return null
        }
        let allAccounts = []
        accounts.forEach((account, idx) => {
            let index = idx + ((paginator.currentPage - 1) * paginator.perPage) + 1
            allAccounts.push(renderAccountRow(account, index))
        })
        return (
            <PaginationWrapper
                paginator={paginator}
                controls={{ search: { enabled: true, collapsed: false } }}
                callbackFX={handlePaginationUpdate}>
                <table className="table">
                    <thead>
                        <tr>
                            <th className="mobile-hide">#</th>
                            <th>Name</th>
                            <th>Account Type</th>
                            <th className="mobile-hide">Created</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allAccounts}
                    </tbody>
                </table>
            </PaginationWrapper>
        )
    }

    return (
        <div className="admin-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>Accounts</h1>
                    </div>
                    <div className="header-actions">
                        <Link className="btn blue" to={buildRoutePath(routes.adminAccountCreate.path)}>
                            Create New Account
                        </Link>
                    </div>
                </div>
            </div>
            <div className="content-wrapper">
                <div className="container">
                    {renderAccounts()}
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(AdminAccountsList))
